import { useEffect, useState } from "react";
import { ProductTableRow } from "./ProductTableRow";
import { TableTag } from "./TableStyles";
import { useProductListData } from "./useProductListData";

const MAX_RECORDS = 35;

const ProductListInWorkspace = (props) => {
  const { portfolios, workspaceId, setRendered, amData } = props;

  const {
    productList,
    ports,
    sortedPortNames,
    ready,
    getAssetName,
  } = useProductListData(workspaceId, portfolios, amData);

  const [readyState, setReadyState] = useState(false);

  useEffect(() => {
    if (ready) setReadyState(true);
  }, [ready]);

  useEffect(() => {
    if (readyState && setRendered) {
      setRendered(true);
      setReadyState(false);
    }
  }, [readyState, setRendered]);

  if (!productList || !ports) return <></>;

  const makeTable = (partialProductList, ports, i) => {
    return (
      <div
        key={`table-${i}`}
        style={{
          flexGrow: 1,
          // width: `${100 / (Math.floor(productList.length / MAX_RECORDS) + 1)}%`,
          //  flexShrink: 1
        }}
      >
        <TableTag key={`table-${i}`}>
          <thead>
            <tr>
              <th>資産型</th>
              <th>運用プロダクト</th>
              <th>期待収益率</th>
              <th>標準偏差</th>
              {ports.map((port) => (
                <th key={port}>{port}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {partialProductList.map((product) => (
              <ProductTableRow
                key={`${product.asset}-${product.id}`}
                product={product}
                sortedPortNames={sortedPortNames}
                getAssetName={getAssetName}
              />
            ))}
          </tbody>
        </TableTag>
      </div>
    );
  };
  const tables = [];
  for (let i = 0, l = productList.length; i < l; i += MAX_RECORDS) {
    tables.push(
      makeTable(productList.slice(i, i + MAX_RECORDS), sortedPortNames, i)
    );
  }

  return (
    <div
      style={{
        display: "flex",
        gap: 20,
        width:
          (57 + 398 + 50 + 70 + 57 * ports.length) *
          (Math.floor(productList.length / MAX_RECORDS) + 1),
        minHeight: 24 * (Math.min(MAX_RECORDS, productList.length) + 1) + 40,
      }}
    >
      {tables.map((table) => table)}{" "}
    </div>
  );
};

// 単一テーブル版もエクスポート
export { ProductListInWorkspaceSingle } from "./ProductListInWorkspaceSingle";
export { ProductListInWorkspace };

